import {isInstanceOf} from 'rlink-type-utils';

export let elementSymbol = Symbol('setOf.elementSymbol');

export default function setOf (elementChecker, ...args) {
  let checker = (obj, key, cname, location, fullName) => {

    let value = obj[key];
    if (!isInstanceOf(value, Set)) {
      return new TypeError(`Value at ${fullName} is not a Set!`);
    }
    for (let element of value) {

      let checkObj = {[elementSymbol]: element};

      let result = elementChecker(checkObj, elementSymbol, cname, location, `${fullName}{${element}}`);
      if (result) {
        return result;
      }
    }
  };
  checker.getCheckerForKey = () => elementChecker;
  checker.makeNew = () => new Set();
  checker.checkerName = 'setOf';
  if (args.length > 0) {
    throw new Error(`Extraneous arguments to ${checker.checkerName}`);
  }
  if (typeof elementChecker !== 'function') {
    throw new Error(`Invalid checker for ${checker.checkerName}: ${elementChecker}`);
  }
  if (!elementChecker.checkerName) {
    throw new Error(`Non-rlink-shape checker for ${checker.checkerName}. Are you trying to mix shapes and PropTypes? (this is not supported)`);
  }
  return checker;
}



// WEBPACK FOOTER //
// ./lib/rlink-shapes/setOf.js